import { Grid } from '@mui/material'
import styled from 'styled-components'

export const GridLogos = styled(Grid)`
  text-align: center;
  margin: 3.5em 0;
  padding: 0 2.5em;
`